import React from 'react';
import styled from 'styled-components';
import { layout } from 'styled-system';

import ButtonImage from '../../assets/button.png';
import GradientSection from '../../components/atoms/GradientSection';

const mMeLink = 'https://m.me/116039056448778';

const Anchor = styled.a`
  display: block;
  position: relative;
  width: 80%;
  margin: auto;
  color: #000;
`;

const ButtonImageWrapper = styled.img`
  ${layout}
`;

const ButtonText = styled.div`
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  text-align: center;
`;

const RedirectToMme = () => {
  return (
    <GradientSection px={2} py={8}>
      <Anchor href={mMeLink}>
        <ButtonImageWrapper src={ButtonImage} width={['auto', '100%']} />
        <ButtonText>請按此登入Facebook Message內查詢你的 M Dollar 及地卡</ButtonText>
      </Anchor>
    </GradientSection>
  );
};

export default RedirectToMme;
